// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const DimensionOut = zod.object({
  "axis": zod.union([zod.enum(['impact', 'feasibility']),zod.null()]).optional(),
  "description": zod.string(),
  "key": zod.string(),
  "label": zod.string(),
  "weight": zod.int()
});

export type DimensionOut = zod.input<typeof DimensionOut>;
export type DimensionOutOutput = zod.output<typeof DimensionOut>;
